module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/fails.js
// module id = 49
// module chunks = 1